export enum NavigationPaths {
    ABOUT_US = 'nosotros',
    HOME = 'inicio',
    STAFF = 'staff',
    CLASSES = 'clases',
    ENROLLMENT = 'matricula',
    LOGIN = 'login',
    ENROLLMENT_CONFIRMATION = '/matricula/confirmacion',
    USER_COURSES = 'mis-cursos'
}
